import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { ContentFulEntryFaq } from '@clux-models';
import { Entry } from 'contentful';
import { Model } from 'src/app/shared/models/clux/model-legacy';

import { Categories } from '../../constants/analyticsCategory.constant';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';

@Component({
  selector: 'app-accordion-messages',
  templateUrl: './accordion-messages.component.html',
  styleUrls: ['./accordion-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AccordionMessagesComponent {
  private googleAnalyticsService = inject(GoogleAnalyticsService);

  @Input() public items: Array<Entry<ContentFulEntryFaq>>;
  public current: number;

  public expandCollapse(index: number, question: string = ''): void {
    if (this.current === index) {
      this.current = -1;
    } else {
      this.current = index;
      /**
       * Track 'OpenFaq' event
       */
      const eventCategory: Model.EventCategory = Object.assign({}, Categories.EventCategories.OpenFaq);
      eventCategory.eventLabel = eventCategory.eventLabel + `'${question}'`;
      this.googleAnalyticsService.eventEmitter(eventCategory);
    }
  }
}
